import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// CURP format: 18-character alphanumeric code issued by Mexico
const CURP_REGEX =
  /^[A-Z][AEIOU][A-Z]{2}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])[HM][A-Z]{2}[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]\d$/i;

const VALID_CURP_STATES = new Set([
  'AS', 'BC', 'BS', 'CC', 'CL', 'CM', 'CS', 'CH', 'DF', 'DG',
  'GT', 'GR', 'HG', 'JC', 'MC', 'MN', 'MS', 'NT', 'NL', 'OC',
  'PL', 'QT', 'QR', 'SP', 'SL', 'SR', 'TC', 'TS', 'TL', 'VZ',
  'YN', 'ZS', 'NE',
]);

export function validateCurp(value: string): boolean {
  const normalized = value.replace(/\s/g, '').toUpperCase();
  if (!CURP_REGEX.test(normalized)) return false;

  const stateCode = normalized.substring(11, 13);
  return VALID_CURP_STATES.has(stateCode);
}

export const curpValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value as string;
  if (!value) return null;
  return validateCurp(value) ? null : { invalidDocument: true };
};